import { createSlice } from "@reduxjs/toolkit";
import {
  socialMediaData,
  socialMediaInitialStatus,
} from "../../../../../types/webCms/homePage/socialMedia";
import { getAllSocialAsync, updateSocialAsync } from "./socialApi";

const initialState: socialMediaInitialStatus<socialMediaData> = {
  loading: false,
  manageLoading: false,
  socialMediaDataList: [],
  countSocialMediaData: 0,
};

const socialMediaSlice = createSlice({
  name: "admin-social",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // get all
    builder
      .addCase(getAllSocialAsync.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getAllSocialAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.socialMediaDataList = action.payload.data;
        state.countSocialMediaData = action.payload.length;
      })
      .addCase(getAllSocialAsync.rejected, (state) => {
        state.loading = false;
        state.socialMediaDataList = [];
        state.countSocialMediaData = 0;
      });

    // update
    builder
      .addCase(updateSocialAsync.pending, (state) => {
        state.manageLoading = true;
      })
      .addCase(updateSocialAsync.fulfilled, (state) => {
        state.manageLoading = false;
      })
      .addCase(updateSocialAsync.rejected, (state) => {
        state.manageLoading = false;
      });
  },
});

export default socialMediaSlice;
